angular.module('tf.controllers')

    .controller('MemberSettingsController', ['$scope', 'user', 'farm', 'FarmService', 'NotificationService', 'HttpService','$timeout',
        function ($scope, user, farm, FarmService, NotificationService, HttpService, $timeout) {
            $scope.user = angular.copy(user);
            $scope.farm = farm;
            $scope.farmGroups = {
                groups : []
            };

            setTimeout(function(){$('.modal input').first().focus();},1);

            function getUserGroups(){
                HttpService.get('user/' + $scope.user.id + '/groups').then(function(res){
                    $scope.groups = res.data;
                });
            }

            getUserGroups();

            $scope.settingsChanged = false;

            $scope.saveSettings = function() {
                $scope.isWorking = true;
                FarmService.saveMember($scope.user, $scope.farmGroups.groups).then(function(){
                    $scope.$close(true);
                    $scope.isWorking = false;
                });
            };

            $scope.deleteMember = function(){
                NotificationService.confirm("Delete Member", "Are you sure that you want to remove "+$scope.user.local.first_name+" from this farm ?", function(){
                    FarmService.removeMember($scope.user).then(function(){
                        $scope.$close(true);
                    });
                });
            };

            $scope.removeMemberFromGroup = function(group){
                NotificationService.confirm("Remove Member From Group", "Are you sure that you want to remove "+$scope.user.local.first_name+" from "+group.name + "?", function() {
                    FarmService.removeMemberFromGroup($scope.user, group).then(function () {
                        $scope.settingsChanged = true;
                        getUserGroups();
                    });
                });
            };

            var unwatchUser = $scope.$watch('user', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatchUser();
                    $scope.settingsChanged = true;
                }
            }, true);
            var unwatchGroup = $scope.$watch('farmGroups', function(newVal, oldVal){
                if(newVal && oldVal && !_.isEqual(newVal, oldVal)){
                    unwatchGroup();
                    $scope.settingsChanged = true;
                }
            }, true);

            $scope.cancel = function(){
                if($scope.settingsChanged) {
                    event.preventDefault();
                    NotificationService.popup('confirm-settings-exit', {
                        onLeave: function(){
                            $timeout(function(){$scope.$close();},200);
                        }
                    },{backdrop : false});
                } else {
                    $scope.$close();
                }
            };

        }]
);